var $db70bbbbf7288cb1$exports = {};
const $db70bbbbf7288cb1$var$displayRightSideBar = document.querySelector("#rightSide-bar");
const $db70bbbbf7288cb1$var$getLatestMovies = async ()=>{
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify({
        category: "industries"
    });
    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };
    const res = await fetch("https://api.voxglobaltech.com/oj/paymentplayer_posts/search?page=1&size=10", requestOptions);
    if (!res.ok) throw new Error(`Http error: Status: ${res.status}`);
    const data = await res.json();
    // console.log("?? ~ file: dataScript.js:26 ~ getLatestNews ~ data:", data)
    return data;
};
const $db70bbbbf7288cb1$var$latestMovies = async ()=>{
    const payLoad = await $db70bbbbf7288cb1$var$getLatestMovies();
    // console.log("?? ~ file: dataScript.js:32 ~ latestNews ~ payLoad:", payLoad.data)
    const rightSideBar = payLoad.data.slice(0, 10);
    let rightSideBarData = rightSideBar.map((data)=>{
        const { title: title, category: category, slug: slug, link: link, excerpt: excerpt, imageLink: imageLink, date: date, leadActor: leadActor } = data;
        return `<li class="flex space-y-1 space-x-3">
   <img alt="" class="w-24 h-24 rounded-md" src=${imageLink}>
   <div class="flex flex-col justify-between">
    <div class="flex flex-col space-y-1">
     <a href=/${link}.html>
      <span class="text-gray-700 text-lg font-semibold">
       ${title}
      </span>
     </a>
    </div>
  <!--  <div class="flex space-x-2 items-center">
     <span>
      Date: ${date}
     </span>
    </div>-->
   </div>
  </li>`;
    }).join("");
    $db70bbbbf7288cb1$var$displayRightSideBar.innerHTML = rightSideBarData;
};
const $db70bbbbf7288cb1$var$includeHTML = ()=>// {
    //   const button = document.querySelector('#triggerEl');
    //   const menu = document.querySelector('#targetEl');
    //   button.addEventListener('click', () => {
    //     menu.classList.toggle('hidden');
    //   });
    //   let langChange = document.querySelector('#lang');
    //   if (localStorage.hasCodeRunBefore && !localStorage.telugu) {
    //     console.log(
    //       '?? ~ file: include.js:37 ~ includeHTML ~ localStorage.hasCodeRunBefore:',
    //       localStorage.hasCodeRunBefore
    //     );
    //     const language = `<li>
    //               <a href="?portal=$english#googtrans(te|en)" target="_self"
    //                    class="block py-2 px-3 md:p-0 text-white rounded md:bg-transparent"></a>
    //          </li>`;
    //     langChange.innerHTML = language;
    //     langChange.addEventListener('click', () => {
    //       localStorage.removeItem('hasCodeRunBefore');
    //       localStorage.setItem('telugu', true);
    //       googleTranslateElementInit('en');
    //     });
    //   } else if (!localStorage.hasCodeRunBefore && localStorage.telugu) {
    //     const language = `<li>
    //           <a href="?portal=$telugu#googtrans(en|te)" target="_self"
    //                class="block py-2 px-3 md:p-0 text-white rounded md:bg-transparent">
    // </a>
    //      </li>`;
    //     langChange.innerHTML = language;
    //     langChange.addEventListener('click', () => {
    //       localStorage.removeItem('telugu');
    //       localStorage.setItem('hasCodeRunBefore', true);
    //       googleTranslateElementInit('te');
    //     });
    //   } else {
    //     const language = `<li>
    //           <a href="?portal=$telugu#googtrans(en|te)" target="_self"
    //                class="block py-2 px-3 md:p-0 text-white rounded md:bg-transparent">
    // </a>
    //      </li>`;
    //     langChange.innerHTML = language;
    //     langChange.addEventListener('click', () => {
    //       localStorage.removeItem('telugu');
    //       localStorage.setItem('hasCodeRunBefore', true);
    //       googleTranslateElementInit('te');
    //     });
    //   }
    // };
    $db70bbbbf7288cb1$var$includeHTML();
$db70bbbbf7288cb1$var$latestMovies();


//# sourceMappingURL=how-passing-the-ccca-would-benefit-nonprofits.ad20fcc0.js.map
